import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import PageScrollTop from './components/pageToTop/PageScrollTop'

// Main Pages 

import MainPage from "./pages/MainPage";

import Error from "./pages/Error";


// Import Css Here 
import './assets/scss/style.scss';


const App = () => {
    return (
        <Router>
            <PageScrollTop>
                <Switch>
                    {/* Nav Pages  */}
                    <Route path={`${process.env.PUBLIC_URL + "/"}`} exact component={MainPage}/>
                    <Route path={`${process.env.PUBLIC_URL + "*"}`} exact component={Error}/>


                </Switch>
            </PageScrollTop>
        </Router>
    )
}


export default App
